module.exports = __webpack_public_path__ + "img/camera-movie.61fb2900.svg";